import produce from 'immer';
import { AnyAction } from 'redux';

import { REACTION_CREATED } from '../actions/Reactions';
import type { RootState } from '~/types/redux/share';

const defaultState: Partial<RootState> = {
  reactionCount: 0,
};

export default function rootReducer(
  state: RootState = defaultState as RootState,
  action: AnyAction
) {
  switch (action.type) {
    case REACTION_CREATED:
      return produce(state, (draftState) => {
        draftState.reactionCount++;
      });

    default:
      return state;
  }
}
